var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{class:_vm.$style.titleColumn},[_c('h4',{staticClass:"is-size-3"},[(_vm.count === 0)?[_vm._v(" No results found ")]:(_vm.count === 1)?[_c('b',[_vm._v(_vm._s(_vm.count))]),_vm._v(" Result found ")]:(_vm.count > 1)?[_c('b',[_vm._v(_vm._s(_vm.count))]),_vm._v(" Results found ")]:_vm._e()],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }